import { type MutationError, trpc } from '@/shared/api';

interface UseSetProductFontsOptions {
  readonly onSuccess?: () => void;
  readonly onError?: () => void;
}

/** 상품의 허용 폰트 저장 — 전체 교체(빈 배열은 전부 해제). 지웠거나 없는 폰트가 섞이면 서버가 400 으로 거부한다. */
export const useSetProductFonts = ({ onSuccess, onError }: UseSetProductFontsOptions = {}) => {
  const mutation = trpc.productManagement.fonts.setForProduct.useMutation({ onSuccess, onError });

  const error: MutationError | null = mutation.error;

  return {
    setProductFonts: mutation.mutate,
    isPending: mutation.isPending,
    error,
  };
};
